module.exports = __webpack_public_path__ + "static/eltwallet.c6dbb42e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/images/eltwallet.png
// module id = 273
// module chunks = 35783957827783